import {action, observable} from "mobx";
import wcpStore from './WordColorPickerStore.js';
import userStore from './UserStore.js';

// Root Store Declaration
// https://stackoverflow.com/questions/54393475/correct-way-of-creating-multiple-stores-with-mobx-and-injecting-it-into-to-a-com

class RootStore {

    @observable
    wcpStore = wcpStore;

    @observable
    userStore = userStore;

    @action
    load() {
        let json = localStorage.getItem('rootStore');
        if (json) {
            const parsed = JSON.parse(json);
            Object.assign(this.wcpStore, parsed.wcpStore );
            Object.assign(this.userStore, parsed.userStore );
        }

    }
}

const rootStore = observable(new RootStore());
rootStore.load();

export default rootStore;